module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_punjabi.45cfa5f9.mp3";